"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNavigationType = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
// istanbul ignore file -- api

const useGetNavigationType = ({
  type,
  enabled = true
}) => {
  const logger = (0, _logger.useLogger)('useBurgerMenuData');
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    loading: loadingUserSegmentationData,
    customerTypeId,
    visitorSegment
  } = (0, _presentationHttp.useUserSegmentationData)();
  const requestParams = (0, _react.useMemo)(() => ({
    customerTypeId: customerTypeId ?? undefined,
    excludeChildren: false,
    lang: language,
    visitorSegment: visitorSegment ?? undefined
  }), [customerTypeId, language, visitorSegment]);
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantApplicationsNavigationNavigation)(tenant, type, requestParams, {
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled: !loadingUserSegmentationData && enabled,
      onError: localError => logger.error(new Error('Cannot fetch navigation items', {
        cause: localError
      }))
    }
  });
  const loading = loadingUserSegmentationData || data === undefined && error === undefined;
  return {
    data: data?.navigationCollection ?? [],
    error,
    loading
  };
};
exports.useGetNavigationType = useGetNavigationType;
